export default "/images/iphone-pic.png?9ab3477b72cfaa1ccc32a8ad99be59bf";